const PersonalData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/personal-data');
const ContactData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/contact-data');
const FiscalData = () => import(/* webpackChunkName: "Interveners" */ '@/components/interveners/fiscal-data');

import DispatchersMixin from '@/mixins/dispatchers';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import Validations from '@/mixins/validations';
import uuidv4 from 'uuid/v4';

export default {
    name: 'IntervenerForm',

    /**
     * @override
     */
    data() {
        return {
            intervenerType: null,
            crsData: null,
            isLoading: false
        };
    },

    mixins: [Validations, DispatchersMixin, formatData, keyed],

    props: {
        data: {
            type: Object,
            required: false
        },
        contributors: {
            type: Array,
            required: true
        },
        contributorType: {
            type: String,
            required: true
        }
    },
    components: {
        PersonalData,
        ContactData,
        FiscalData
    },
    methods: {
        /**
         * Cancela los cambios
         */
        cancel() {
            this.formatData();
            this.modifiedData = {};
            this.$emit('cancel');
        },
        /**
         * Lanzar evento con la información del aportante introducida
         */
        submit() {
            const properties = ['personalData', 'contactData', 'fiscalData'];
            const _contributor = {
                uuid: uuidv4()
            };

            this.isLoading = true;
            Promise.all(
                // eslint-disable-next-line array-callback-return
                properties.map(prop => {
                    return this.$refs[`${prop}-${this.key}`].fetchValidatedData().then(data => ({ prop, data }));
                }
                )
            )
            .then(results => {
                results.forEach(x => {
                    if (!x.data) {
                        throw new Error(x.prop);
                    }
                    _contributor[x.prop] = x.data;
                });

                this.isLoading = false;
                this.$emit('save', _contributor);
            })
            .catch(err => {
                this.isLoading = false;
                this.$toast.error('Aportante', 'Revisa los campos marcados en rojo');
                console.log(err);
            });
        }
    }
};
